import axiosClient from './axiosService';

const BASE_URL = '/students';

export const getAllStudents = () =>
    axiosClient.get(BASE_URL);

export const getStudentById = (id) =>
    axiosClient.get(`${BASE_URL}/${id}`);

export const createStudent = (student) =>
    axiosClient.post(BASE_URL, student);

export const updateStudent = (id, student) =>
    axiosClient.put(`${BASE_URL}/${id}`, student);

export const updateStudentStatus = (id, studentStatus) =>
    axiosClient.patch(`${BASE_URL}/${id}/status`, null, {
        params: { studentStatus },
    });

export const deleteStudent = (id) =>
    axiosClient.delete(`${BASE_URL}/${id}`);

export const getStudentsByName = (fullName) =>
    axiosClient.get(`${BASE_URL}/search/by-name`, {
        params: { fullName },
    });

export const getStudentByEmail = (emailAddress) =>
    axiosClient.get(`${BASE_URL}/search/by-email`, {
        params: { emailAddress },
    });

export const getStudentsByGender = (gender) =>
    axiosClient.get(`${BASE_URL}/search/by-gender`, {
        params: { gender },
    });

export const getStudentsByPhone = (phoneNumber) =>
    axiosClient.get(`${BASE_URL}/search/by-phone`, {
        params: { phoneNumber },
    });

export const getTotalStudentCount = () =>
    axiosClient.get(`${BASE_URL}/count`);

export const uploadProfileImage = (studentId, profileImage) => {
    const formData = new FormData();
    formData.append("profileImage", profileImage);

    return axiosClient.post(
        `/students/${studentId}/uploadProfileImage`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

export const getProfileImage = (studentId) =>
    axiosClient.get(`${BASE_URL}/${studentId}/profileImage`, {
        responseType: 'arraybuffer',
    });
